
import { MenuFoldOutlined, MenuUnfoldOutlined } from "@ant-design/icons";
import { Button, Flex, Layout, theme } from "antd";
import styled from "styled-components";
import { ChangeLang } from "../changeLang/ChangeLangNav";
import { UserDropDown } from "../userDrop/UserDropDown";
import styles from "./header.module.css";
import { useTranslation } from "react-i18next";
import { Notifications } from "../notifications/Notifications";
type Props = {
  sidebarCollapsed: boolean,
  setSidebarCollapsed: (a: boolean) => void
}

const StyledFlex = styled(Flex)`
  &>div{
    display: flex;
    align-items: center;
  }
`
export const Header = ({ sidebarCollapsed, setSidebarCollapsed }: Props) => {
    const {t} = useTranslation()

  const {
    token: { colorBgContainer },
  } = theme.useToken();


  return (
    <Layout.Header
      style={{
        padding: "0 15px 0 0",
        background: colorBgContainer
      }}
    >
      <StyledFlex gap='middle' justify='space-between'>
        <div>
          <Button
            type="text"
            icon={sidebarCollapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
            onClick={() => setSidebarCollapsed(!sidebarCollapsed)}
            style={{
              fontSize: '16px',
              width: 64,
              height: 64,
            }}
          />
          <h3>{ t('header.interactive_map') }</h3>
          
        </div>
        <div className={styles.headerRight}>
        <ChangeLang />
            <UserDropDown/>
        <Notifications/>
        </div>
      </StyledFlex>
    </Layout.Header>
  )
}